export const parseQuery = queryString => {
  const query = {}
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&')

  for (const element of pairs) {
    const pair = element.split('=')

    if (Object.keys(query).includes(decodeURIComponent(pair[0]))) {
      if (Array.isArray(query[decodeURIComponent(pair[0])])) query[decodeURIComponent(pair[0])].push(decodeURIComponent(pair[1] || ''))
      else query[decodeURIComponent(pair[0])] = [query[decodeURIComponent(pair[0])], decodeURIComponent(pair[1] || '')]
    } else {
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
    }
  }

  return query
}

export const buildUrlSearchParams = params => {
  if (params == null || !Object.keys(params).length) {
    return ''
  }

  let urlSearchParams = []

  for (const param in params) {
    urlSearchParams.push([param, encodeURI(params[param])].join('='))
  }

  return '?' + urlSearchParams.join('&')
}
